import React from "react";
import ReactDOM from "react-dom/client";
import { PublicFooter } from "@dev-apps/common-ui-components";

const root = ReactDOM.createRoot(document.getElementById("sewp-legacy-footer"));
root.render(
  <React.StrictMode>
    <PublicFooter basePath={process.env.NEXT_PUBLIC_BASE_PATH} />
  </React.StrictMode>
)
